<script setup lang="ts">
    import { reactive } from 'vue';
    import { bsAlert, AlertTypes } from '@shared/components/BsAlerts';
    import { syncModeraterna, moveFromSmsQueue, triggerExport } from './Miscellaneous.access';

    const state = reactive({
        activeTab: 'custom' as 'custom' | 'datamanagement',
        busy: false,
    });

    async function run(action: () => Promise<void>): Promise<void> {
        if (state.busy) return;
        state.busy = true;
        try {
            await action();
            bsAlert({ type: AlertTypes.Success, title: 'Done', content: 'Action completed' });
        } catch {
            bsAlert({ type: AlertTypes.Danger, title: 'Error', content: 'Action failed' });
        } finally {
            state.busy = false;
        }
    }
</script>

<template>
    <h3>Misc</h3>

    <ul class="tabs list-unstyled">
        <li :class="{ active: state.activeTab === 'custom' }">
            <a href="#" @click.prevent="state.activeTab = 'custom'">Custom customer functions</a>
        </li>
        <li :class="{ active: state.activeTab === 'datamanagement' }">
            <a href="#" @click.prevent="state.activeTab = 'datamanagement'">Data management</a>
        </li>
    </ul>

    <div class="tab-content">
        <div v-if="state.activeTab === 'custom'">
            <h4>Moderaterna</h4>
            <button class="btn btn-default" :disabled="state.busy" @click="run(() => syncModeraterna('organizations'))">
                Synchronize Organizations
            </button>
            <button class="btn btn-default" :disabled="state.busy" @click="run(() => syncModeraterna('users'))">
                Synchronize Users
            </button>
            <h4>Data export</h4>
            <button class="btn btn-default" :disabled="state.busy" @click="run(triggerExport)">TestExport</button>
        </div>

        <div v-if="state.activeTab === 'datamanagement'">
            <h4>Sms</h4>
            <button class="btn btn-default" :disabled="state.busy" @click="run(moveFromSmsQueue)">
                Move 1000 From SmsRecipientQueue to SmsRecipient
            </button>
        </div>
    </div>
</template>

<script lang="ts">
    export default {
        name: 'Miscellaneous',
    };
</script>

<style></style>
